import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = [
    'state',
    'city',
    'prop'
  ]

  // action
  filter(event) {
    if (event.currentTarget.classList.contains('js-country')) {
      if (this.hasStateTarget) this.stateTarget.value = ''
      if (this.hasCityTarget) this.cityTarget.value = ''
    }
    this.cleanAndSubmit()
  }

  get params() {
    return this.propTargets.filter(t => (t.name == 'favorite' && t.checked) || (t.name != 'favorite' && t.value != '')).map(t => `${t.name}=${t.value}`).join("&")
  }

  cleanAndSubmit() {
    const url = `${window.location.pathname}?${this.params}`
    Turbo.visit(url)
  }

  // action
  search(e) {
    let key = e.charCode ? e.charCode : e.keyCode ? e.keyCode : 0
    if (key == 13) {
      this.cleanAndSubmit()
    }
  }

}
